import * as React from 'react';

import classnames from 'classnames';

import {RadioGroupSimple} from 'shells/radio-group-simple/radio-group-simple';

import {
    isMarketingReportKey,
    EDITION_GAP_SELECT_VALUES,
    GAP_SELECT_VALUES_DAY_TO_YEAR,
    GAP_SELECT_VALUES_DAY_TO_MONTH,
    DAY_TO_MONTH_REPORT_KEYS,
} from './report-constants';
import {ReportProviderContext} from './report-provider-context';
import type {ReportGap, ReportKey} from './report-types';

import styles from './report-chart-header.module.css';

type Props = {
    gap?: {
        reportGap: ReportGap;
        onUpdateGap: (arg1: ReportGap) => void;
    };
    reportKey: ReportKey;
    extraContent?: React.ReactNode;
    titleProps: {
        title: string;
        isAlwaysShown: boolean;
    };
};

/*
 * This component provides a set of text buttons allowing the "gap" (or "binning")
 * of a report to be changed between day, week, month, quarter, and year.
 */
export function ReportChartHeader({gap, titleProps, reportKey, extraContent}: Props) {
    const getGapSelectValues = () => {
        if (reportKey === 'editionEngagement') {
            return EDITION_GAP_SELECT_VALUES;
        }
        // @ts-expect-error
        if (DAY_TO_MONTH_REPORT_KEYS.includes(reportKey)) {
            return GAP_SELECT_VALUES_DAY_TO_MONTH;
        }

        return GAP_SELECT_VALUES_DAY_TO_YEAR;
    };

    const gapSelectValues = getGapSelectValues();

    return (
        <ReportProviderContext.Consumer>
            {/* @ts-expect-error */}
            {({chartData}) => (
                <React.Fragment>
                    <div
                        style={isMarketingReportKey(reportKey) ? {top: '64px'} : undefined}
                        className={styles['extra-content-container']}
                    >
                        {/* If we don't have any chart data, we won't be showing
                        the rest of the header so we shouldn't show the extra
                        content. */}
                        {chartData ? extraContent : undefined}
                    </div>
                    {/* If the report is configured to always show the title, we'll show it
                    in the header. Otherwise, we'll show it only in chart downloads. */}
                    <div
                        className={classnames(
                            'download-chart-header',
                            titleProps.isAlwaysShown
                                ? styles['chart-title--always-shown']
                                : styles['chart-title--download-only']
                        )}
                    >
                        {titleProps.title}
                    </div>
                    {gap ? (
                        <div
                            style={isMarketingReportKey(reportKey) ? {top: '64px'} : undefined}
                            data-html2canvas-ignore='true'
                            className={styles['hero-chart-segments']}
                        >
                            <RadioGroupSimple
                                name={`gap-${reportKey}`}
                                isWide={true}
                                // @ts-expect-error
                                options={gapSelectValues}
                                selectedOption={gapSelectValues.find(
                                    (gapSelectValue) => gapSelectValue.id === gap.reportGap
                                )}
                                onChange={gap.onUpdateGap}
                            />
                        </div>
                    ) : undefined}
                </React.Fragment>
            )}
        </ReportProviderContext.Consumer>
    );
}
